import {
  DeleteMediaFileRequest, GetMediaFileMetadataRequest,
  ListMediaFilesRequest, MediaFileMetadata,
  SetMediaUsageRequest, UploadMediaFileRequest, UploadTemporaryMediaFileRequest,
  PagedMediaFileResponse
} from '@3m5/sm_publish-frontend-api'
import actionCreatorFactory from 'typescript-fsa'
import { StringPrimitiveWrapper, UploadedFile, GetUploadedFileAsBase64Request, CheckFileUploadRequest } from '../../api/filescanner/types'
import { UploadThumbnailForMediaFileRequest } from '@3m5/sm_publish-frontend-api/apis/MediaFileApi'

const actionCreator = actionCreatorFactory('IMAGES')

/*
 * Actions
 */

export const setUploadedFileId = actionCreator<string>('SET_UPLOADED_FILE_ID')
export const setUploadedMediaFile = actionCreator<MediaFileMetadata | undefined>('SET_UPLOADED_MEDIA_FILE')
export const getMediaFileMetadataInitiated = actionCreator<GetMediaFileMetadataRequest>('GET_MEDIA_FILE_METADATA_INITIATED')
export const getMediaFileMetadata = actionCreator.async<GetMediaFileMetadataRequest, MediaFileMetadata>('GET_MEDIA_FILE_METADATA')

export const uploadMediaFileInitiated = actionCreator<UploadMediaFileRequest>('UPLOAD_MEDIA_FILE_INITIATED')
export const uploadMediaFile = actionCreator.async<UploadMediaFileRequest, MediaFileMetadata>('UPLOAD_MEDIA_FILE')

export const uploadTemporaryMediaFileInitiated = actionCreator<UploadTemporaryMediaFileRequest>('UPLOAD_TEMPORARY_MEDIA_FILE_INITIATED')
export const uploadTemporaryMediaFile = actionCreator.async<UploadTemporaryMediaFileRequest, MediaFileMetadata>('UPLOAD_TEMPORARY_MEDIA_FILE')

export const listMediaFilesInitiated = actionCreator<ListMediaFilesRequest>('LIST_MEDIA_FILES_INITIATED')
export const listMediaFiles = actionCreator.async<ListMediaFilesRequest, PagedMediaFileResponse>('LIST_MEDIA_FILES')

export const listProfileImagesInitiated = actionCreator('LIST_PROFILE_IMAGES_INITIATED')
export const listProfileImages = actionCreator.async<undefined, MediaFileMetadata[]>('LIST_PROFILE_IMAGES')

export const listCoverImagesInitiated = actionCreator('LIST_COVER_IMAGES_INITIATED')
export const listCoverImages = actionCreator.async<undefined, MediaFileMetadata[]>('LIST_COVER_IMAGES')

export const setMediaFileUsageInitiated = actionCreator<SetMediaUsageRequest>('SET_MEDIA_FILE_USAGE_INITIATED')
export const setMediaFileUsage = actionCreator.async<SetMediaUsageRequest, MediaFileMetadata>('SET_MEDIA_FILE_USAGE')

export const deleteMediaFileInitiated = actionCreator<DeleteMediaFileRequest>('DELETE_MEDIA_FILE_METADATA_INITIATED')
export const deleteMediaFile = actionCreator.async<DeleteMediaFileRequest, undefined>('DELETE_MEDIA_FILE_METADATA')

export const checkFileUploadInitiated = actionCreator<CheckFileUploadRequest>('CHECK_FILE_UPLOAD_INITIATED')
export const checkFileUpload = actionCreator.async<CheckFileUploadRequest, StringPrimitiveWrapper>('CHECK_FILE_UPLOAD')

export const getUploadedFileAsBase64Initiated = actionCreator<GetUploadedFileAsBase64Request>('GET_UPLOADED_FILE_AS_BASE_64_INITIATED')
export const getUploadedFileAsBase64 = actionCreator.async<GetUploadedFileAsBase64Request, UploadedFile>('GET_UPLOADED_FILE_AS_BASE_64')

export const uploadThumbnailForMediaFileInitiated = actionCreator<UploadThumbnailForMediaFileRequest>('UPLOAD_THUMBNAIL_FOR_MEDIA_FILE_INITIATED')
export const uploadThumbnailForMediaFile = actionCreator.async<UploadThumbnailForMediaFileRequest, MediaFileMetadata>('UPLOAD_THUMBNAIL_FOR_MEDIA_FILE')
